import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import UsersPage from "../../components/Users/Users";

const usersSearchSchema = z.object({
  page: z.number().catch(1),
});

export const Route = createFileRoute("/_layout/users")({
  component: UsersPage,
  validateSearch: (search) => usersSearchSchema.parse(search),
});
